function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M15.36 16H.64a.64.64 0 01-.64-.64V.64A.64.64 0 01.64 0h7.2A.16.16 0 018 .16v1.12a.16.16 0 01-.16.16h-6.4v13.12h13.12v-6.4a.16.16 0 01.16-.16h1.12a.16.16 0 01.16.16v7.2a.64.64 0 01-.64.64zM13.177 1.743L12.133.699a.16.16 0 01.094-.272l3.588-.42a.16.16 0 01.178.178l-.42 3.588a.16.16 0 01-.272.094l-1.048-1.048L9.13 7.943a.16.16 0 01-.226 0l-.848-.848a.16.16 0 010-.226l5.122-5.126z"
});

const SvgOpenIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOpenIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/open-icon.d372c97c.svg";
export { ForwardRef as ReactComponent };